/* eslint-disable no-alert, no-console */
import { apiRequest } from '@/calls/helpers';

const getExhibitionsDetail = async (id, locale) => apiRequest(`routes/get_exhibition?id=${id}&lang=${locale}`, {
  method: 'GET',
});

const getCurrentExhibition = async (locale) => {
  let url = 'routes/get_current_exhibition';
  if (locale && locale !== '') {
    url = `${url}?lang=${locale}`;
  }
  return apiRequest(url, {
    method: 'GET',
  });
};

export {
  // eslint-disable-next-line
  getExhibitionsDetail,
  getCurrentExhibition
};
